export default "__VITE_ASSET__009190ed__"